import { render, staticRenderFns } from "./ApiMenu.vue?vue&type=template&id=1e44a876&scoped=true&"
import script from "./ApiMenu.vue?vue&type=script&lang=js&"
export * from "./ApiMenu.vue?vue&type=script&lang=js&"
import style0 from "./ApiMenu.vue?vue&type=style&index=0&id=1e44a876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e44a876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-release-cn/s01_haiyiai_release-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e44a876')) {
      api.createRecord('1e44a876', component.options)
    } else {
      api.reload('1e44a876', component.options)
    }
    module.hot.accept("./ApiMenu.vue?vue&type=template&id=1e44a876&scoped=true&", function () {
      api.rerender('1e44a876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/api/components/ApiMenu.vue"
export default component.exports